import React from 'react';

import { VendorExpensesProvider } from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/vendorExpensesContextProvider';
import VendorExpensesFilters from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/components/Filters';
import VendorExpensesGrid from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/components/AgGrid';

const DashboardVendorExpensesRoute = () => {
  return (
    <VendorExpensesProvider>
      <VendorExpensesFilters />
      <VendorExpensesGrid />
    </VendorExpensesProvider>
  );
};

export default DashboardVendorExpensesRoute;
